/**
 * @generated SignedSource<<5589b2cb387954b343069940db16c566>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteRequest = {
  id: string;
};
export type AccountBrandsPanelArchiveMutation$variables = {
  input: DeleteRequest;
};
export type AccountBrandsPanelArchiveMutation$data = {
  readonly archiveBrand: {
    readonly id: string;
  };
};
export type AccountBrandsPanelArchiveMutation = {
  response: AccountBrandsPanelArchiveMutation$data;
  variables: AccountBrandsPanelArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminBrand",
    "kind": "LinkedField",
    "name": "archiveBrand",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountBrandsPanelArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountBrandsPanelArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2093aa7e4b4bae289b3ffa1f2824d1f1",
    "id": null,
    "metadata": {},
    "name": "AccountBrandsPanelArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation AccountBrandsPanelArchiveMutation(\n  $input: DeleteRequest!\n) {\n  archiveBrand(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "61479ed06d29f28c851db30bd87218f3";

export default node;
